import { createContext } from 'react';

import { AuthenticateDialogContextProps } from './AuthenticateDialog.types';

export const AuthenticateDialogContext = createContext({} as AuthenticateDialogContextProps);
